<template>
	<div class="transaction_list">
		<ModalDelete ref="ModalDelete" confirm-text="ya" @action="cancel">
			<template v-slot:title>
				<span class="primary--text text-capitalize font-weight-bold">Batalkan Transaksi</span>
			</template>
			<template v-slot:body>
				<div class="text-center">Apakah Anda yakin untuk membatalkan transaksi "<span class="text-capitalize font-weight-bold">{{ trx_selected_code }}</span>"?</div>
			</template>
		</ModalDelete>
		<ModalDelete ref="ModalReceive" confirm-text="ya" confirm-color="primary" @action="receive">
			<template v-slot:title>
				<span class="primary--text text-capitalize font-weight-bold">konfirmasi penerimaan</span>
			</template>
			<template v-slot:body>
				<div class="text-center">Apakah Anda yakin sudah menerima transaksi ini?</div>
			</template>
		</ModalDelete>
		<v-col class="pt-5">
			<div>
				<v-row>
					<v-col cols="12" md="2" class="py-0 pr-md-0">
						<profile-menu></profile-menu>
					</v-col>
					<v-col cols="12" md="10" class="pl-md-5 py-0 mt-5 mt-md-0">
						<div>
							<!-- Filter data -->
							<v-card outlined elevation="0" id="filter-card" class="my-5">
								<v-card-text>
									<v-form>
										<v-row>
											<v-col cols="12" sm="3" class="py-0" :class="{'mb-2': isMobile}">
												<v-menu
													ref="menuDate"
													v-model="menuDate"
													:close-on-content-click="true"
													transition="scale-transition"
													offset-y
													min-width="290px"
												>
													<template v-slot:activator="{ on, attrs }">
														<v-text-field
															v-model="dateRangeText"
															prepend-inner-icon="mdi-calendar"
															readonly
															v-bind="attrs"
															v-on="on"
															hide-details="auto"
															outlined
															clearable
															densed
															class="datePickerSmall"
															placeholder="Tanggal"
															@click:clear="clearDate"
														></v-text-field>
													</template>
													<v-date-picker
														v-model="filter.dateRange"
														no-title
														@click:date="searchTrx"
														@change="tglTransaksiFilter.value = filter.dateRange"
													>
													</v-date-picker>
												</v-menu>
											</v-col>
											
											<v-col cols="12" sm="3" class="py-0" :class="{'mb-2': isMobile}">
												<!-- <v-combobox
													v-model="filter.type"
													dense
													outlined
													item-text="label"
													item-value="value"
													hide-details="auto"
													:items="filterOptions"
												></v-combobox> -->
											</v-col>

											<v-col cols="12" sm="6" class="py-0" :class="{'mb-2': isMobile}">
												<v-text-field
													v-model="filter.search"
													outlined
													small
													dense
													clearable
													hide-details="auto"
													class="searchInput"
													@input="invoiceNoFilter.value = filter.search"
													@click:clear="clearSearch"
													@keyup.enter="searchTrx"
													placeholder="Masukkan No. Transaksi"
												>
													<div slot="append">
														<v-btn
															small
															elevation="2"
															color="success"
															@click="searchTrx"
														>
															<v-icon center>
																mdi-magnify
															</v-icon>
														</v-btn>
													</div>
												</v-text-field>
											</v-col>
										</v-row>

									</v-form>
								</v-card-text>
							</v-card>

							<template v-if="loadingList">
								<div class="pb-4">
									<v-card outlined elevation="0" class="py-3 rounded-lg">
										<v-col class="pb-0">
											<vcl :width='300' :height='65'>
												<rect x="0" y="0" rx="2" ry="2" width="60" height="5" />
												<rect x="260" y="0" rx="2" ry="2" width="40" height="5" />
												<rect x="5" y="15" rx="2" ry="2" width="80" height="5" />
												<rect x="5" y="25" rx="2" ry="2" width="95" height="5" />
												<rect x="5" y="35" rx="2" ry="2" width="155" height="10" />
												<rect x="5" y="50" rx="2" ry="2" width="45" height="5" />
												<rect x="70" y="50" rx="2" ry="2" width="45" height="5" />
												<rect x="5" y="60" rx="2" ry="2" width="45" height="5" />
												<rect x="70" y="60" rx="2" ry="2" width="45" height="5" />
												<rect x="240" y="18" rx="2" ry="2" width="35" height="12" />
												<rect x="220" y="34" rx="2" ry="2" width="75" height="12" />
												<rect x="220" y="50" rx="2" ry="2" width="75" height="12" />
											</vcl>
										</v-col>
									</v-card>
								</div>
							</template>
							
							<template v-else>
								<template v-if="transactionData.length == 0 && transactionPagination">
									<v-card outlined elevation="0" class="py-3 rounded-lg">
										<v-row class="justify-center">
											<v-col cols="7" md="5">
												<v-img width="100%" src="/assets/icons/no-cart.svg"></v-img>
											</v-col>
										</v-row>
										<div class="text-center pb-3">
											<template v-if="invoiceNoFilter.value !== ''">
												<div class="pt-1 text-body-1 font-weight-bold">Tidak ada data pesanan yang sesuai dengan pencarian Anda.</div>
											</template>
											<template v-else>
												<div class="pt-1 text-body-1 font-weight-bold">Belum ada pesanan</div>
												<div class="pt-1 text-body-2">Belanja kebutuhanmu segera di HWI Ecommerce</div>
												<div class="pt-4">
													<router-link to="/" class="text-deco">
														<v-btn depressed large color="primary" class="text-capitalize font-weight-bold rounded-lg">Belanja Sekarang</v-btn>
													</router-link>
												</div>
											</template>
										</div>
									</v-card>
								</template>
								
								<template v-else>
									<div class="pb-4" v-for="data in transactionData" :key="data.trx_code">
										<v-card outlined elevation="0" class="py-3 rounded-lg">
											<v-row class="px-3">
												<v-col class="py-1 text-body-2 my-auto">
													<div class="d-block d-md-flex font-weight-bold">
														<div>Transaksi</div>
														<div class="pt-1 pt-md-0 pl-md-1 primary--text">{{ data.trx_code }}</div>
													</div>
												</v-col>
												<v-col class="py-0 text-right" v-if="data.trx_payment_method == 'Bank Transfer'">
													<v-btn @click="showModalDelete(data.trx_id, data.trx_code, 'Bank Transfer')" text color="red" class="" v-if="data.trx_status == 'Menunggu Pembayaran'">
														<span class="text-capitalize text-body-2 font-weight-bold">Batalkan Transaksi</span>
													</v-btn>
												</v-col>
												<v-col class="py-0 text-right" v-if="data.trx_payment_method == 'Virtual Account'">
													<v-btn @click="showModalDelete(data.trx_id, data.trx_code, 'Virtual Account')" text color="red" class="" v-if="data.trx_status == 'Menunggu Pembayaran'">
														<span class="text-capitalize text-body-2 font-weight-bold">Batalkan Transaksi</span>
													</v-btn>
												</v-col>
											</v-row>
											<div class="px-3 py-2"><v-divider></v-divider></div>
											<v-row class="pl-3 pl-md-5 pr-3">
												<v-col cols="12" sm="8" md="9" class="pl-3 pl-md-5 py-0 text-body-2">
													<div class="pt-3 d-flex align-center justify-space-between">
														<div class="d-flex">
															<div class="font-size-13 grey--text text--darken-1">Total :</div>
															<div class="pl-3 text-body-2 red--text font-weight-bold">{{ data.trx_grand_total | toRupiah }}</div>
														</div>
														<div class="pt-1 pt-md-0 d-flex">
															<div class="pl-md-3 font-size-13 grey--text text--darken-1">Waktu :</div>
															<div class="pl-3 text-body-2 font-weight-bold">{{ data.trx_datetime | tanggaljam }}</div>
														</div>
													</div>

													<StatusTransaction :status="data.trx_status"></StatusTransaction>
													
													<div class="pt-4">
														<v-row>
															<v-col cols="6" md="4" class="py-0">
																<div class="font-size-13 grey--text text--darken-1">Metode Pembayaran </div>
															</v-col>
															<v-col cols="6" md="8" class="pl-0 pl-md-3 py-0">
																<div class="font-size-13 font-weight-bold">: {{ data.trx_payment_note }}</div>
															</v-col>
														</v-row>

														<!-- <v-row>
															<v-col cols="6" md="4" class="pt-2 pb-0">
																<div v-if="data.trx_payment_method == 'Bank Transfer'" class="font-size-13 grey--text text--darken-1">Rekening Pembayaran</div>
																<div v-else-if="data.trx_payment_method == 'Virtual Account'" class="font-size-13 grey--text text--darken-1">No. Virtual Account</div>
															</v-col>
															<v-col cols="6" md="8" class="pl-0 pl-md-3 pt-2 pb-0">
																<div v-if="data.trx_payment_method != 'Bank Transfer'" class="font-size-13 font-weight-bold">: {{ data.trx_midtrans_payment_code }}</div>
																<div v-else-if="data.trx_payment_method != 'Virtual Account'" class="font-size-13 font-weight-bold">: {{ data.trx_midtrans_payment_code }}</div>
															</v-col>
														</v-row> -->
													</div>
												</v-col>
												<v-col cols="12" sm="4" md="3" class="text-center text-md-right">
													<div class="ml-0 ml-md-5">
														<v-img v-if="data.payment_image" width="120" class="mx-auto" :src="data.payment_image"></v-img>
														<!-- <v-img v-if="data.trx_payment_method == 'payment_store'" width="40" class="mx-auto" src="/assets/icons/market-icon.svg"></v-img> -->
													</div>
													<v-btn small v-if="data.trx_status == 'Menunggu Pembayaran' && data.trx_pdf_url" color="primary" class="mt-1 px-5 py-4" @click="downloadPDF(data.trx_pdf_url)">
														<div class="font-weight-bold">Cara Pembayaran</div>
													</v-btn>
													<!-- <v-btn small v-if="data.trx_status == 'on_delivery'" color="primary" class="mt-1 px-5 py-4" @click="confirmReceived(data.trx_id, data.trx_code)">
														<div class="font-weight-bold">Konfirmasi Penerimaan</div>
													</v-btn> -->
													<v-btn small outlined depressed color="primary" class="mt-3 px-5 py-4" @click="gotoDetail(data.trx_id)">
														<div class="font-weight-bold">Detail Transaksi</div>
													</v-btn>
													
												</v-col>
											</v-row>
										</v-card>
									</div>
									<v-row class="pt-4 justify-center" v-if="transactionPagination.total_page > 1">
										<v-pagination v-model="page" @input="changePage" :length="transactionPagination.total_page" class="elevation-0"></v-pagination>
									</v-row>
								</template>
							</template>
						</div>
					</v-col>
				</v-row>
			</div>
		</v-col>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import ProfileMenu from '@/components/layout/store/ProfileMenu';
import StatusTransaction from '@/components/StatusTransaction';
import ModalDelete from '@/components/ModalDelete'
import moment from 'moment'

export default {
	component: { moment },
	components: {
		ProfileMenu, StatusTransaction, ModalDelete
	},
	data () {
		return {
			page: 1,
			limit: 5,
			params: [],
			sortBy: 'trx_id',
			sortDir: 'DESC',
			trx_selected_code: '',
			trx_selected_id: '',
			loadingList: false,
			menuDate: false,
      filterOptions: [
        {
          label: 'No. Transaksi',
          value: 'invoice'
        },
        // {
        //   label: 'Nama Pembeli',
        //   value: 'buyer'
        // }
      ],
			filter: {
        type: {
          label: 'No. Transaksi',
          value: 'invoice'
        },
        search: '',
        filterId: null,
        sortId: null,
        dateRange: null
      },
			invoiceNoFilter: {
        value: '',
        comparison: 'like',
        type: 'string',
        field: 'trx_code',
      },
      tglTransaksiFilter: {
        value: '',
        comparison: 'like',
        type: 'string',
        field: 'trx_datetime',
      },
      statusFilter: {
        value: '',
        comparison: 'yes',
        type: 'list',
        field: 'trx_status',
      },
      paymentFilter: {
        value: 'payment_store',
        comparison: '=',
        type: 'string',
        field: 'trx_payment_method',
      },
			isMobile: false
		}
	},
	computed: {
		...mapState('transaction', ['transactionData', 'transactionPagination']),
		dateRangeText: {
      get(){
        let dates = (this.filter.dateRange) ? new Date(this.filter.dateRange) : null
        return (dates) ? moment(dates).format('DD MMM YYYY') : null
      },
      set(){
        let dates = (this.filter.dateRange) ? new Date(this.filter.dateRange) : null
        return (dates) ? moment(dates).format('DD MMM YYYY') : null
      } 
    }
	},
	methods :{
		...mapActions('transaction', ['getTransaction', 'cancelTransaction']),

		async clearDate() {
      this.filter.dateRange = await null
      this.tglTransaksiFilter.value = await this.filter.dateRange
      this.searchTrx()
    },

		async searchTrx() {
      this.loadingList = await true
      let params = await []
      if (this.filter.type.value === 'invoice') {
        if (this.invoiceNoFilter.value) await params.push(this.invoiceNoFilter)
      }
      if (this.tglTransaksiFilter.value) await params.push(this.tglTransaksiFilter)

      // if (this.allowedStatus.length === 1) this.statusFilter.value = await this.allowedStatus
      // if (this.statusFilter.value) await params.push(this.statusFilter)

      this.page = await 1
      await this.getTransaction(
        this.queryString({
          limit: this.limit,
          page: this.page,
          sort: this.sortBy,
          dir: this.sortDir,
          params: params
        })
      ).then(async () => {
        // this.listPesanan = await this.filterAllowedStatus(this.pesananData)
        this.loadingList = false
      }).catch(() => {
        this.loadingList = false
      })
    },

    async clearSearch() {
      this.filter.search = await ''
      this.filter.type = await {
        label: 'No. Transaksi',
        value: 'invoice'
      }
      // this.buyerNameFilter.value = await ''
      this.invoiceNoFilter.value = await ''
      this.searchTrx()
    },

		showModalDelete(id, trx_code, type) {
			this.trx_selected_code = trx_code
			this.trx_selected_id = id
			this.type_payment = type
			this.$refs.ModalDelete.modalShow()
		},
		cancel() {
			// if (this.type_payment == 'Bank Transfer') {
			// 	this.cancelBank({invoice: this.trx_selected_code}).then(() => {
			// 		this.getTransaction({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir})
			// 	})
			// } else if (this.type_payment == 'Virtual Account') {
			// 	this.cancelVA({invoice: this.trx_selected_code}).then(() => {
			// 		this.getTransaction({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir})
			// 	})
			// }

			this.cancelTransaction({trx_id: this.trx_selected_id}).then(() => {
				this.getTransaction({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir})
			})
		},
		downloadPDF(pdf) {
			window.open(pdf)
		},
		confirmReceived(id, trx_code) {
			this.trx_selected_code = trx_code
			this.trx_selected_id = id
			this.$refs.ModalReceive.modalShow()
		},
		receive() {
			this.receiveTransaction({trx_id: this.trx_selected_code}).then(() => {
				this.getTransaction({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir})
			})
		},
		gotoDetail(invoice) {
			this.$router.push({name: 'transaction-detail', params : { id: invoice} })
		},
		changePage(page) {
			this.page = page
			this.getTransaction({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir})
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', 'Transaksi');
		this.getTransaction({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir})
	}
};
</script>